/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Genius_EyebrowInputs */

const tr_landing_genius_eyebrow = /** @type {(inputs: Landing_Genius_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`genius ai · çoklu ajan sistemi`)
};

const en_landing_genius_eyebrow = /** @type {(inputs: Landing_Genius_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`genius ai · multi-agent system`)
};

const de_landing_genius_eyebrow = /** @type {(inputs: Landing_Genius_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`genius ai · Multi-Agenten-System`)
};

const ru_landing_genius_eyebrow = /** @type {(inputs: Landing_Genius_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`genius ai · мультиагентная система`)
};

/**
* | output |
* | --- |
* | "genius ai · multi-agent system" |
*
* @param {Landing_Genius_EyebrowInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_genius_eyebrow = /** @type {((inputs?: Landing_Genius_EyebrowInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Genius_EyebrowInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_genius_eyebrow(inputs)
	if (locale === "de") return de_landing_genius_eyebrow(inputs)
	if (locale === "ru") return ru_landing_genius_eyebrow(inputs)
	return tr_landing_genius_eyebrow(inputs)
});